import styled from "styled-components";

interface BubbleChildProps {
  variant: "user" | "average";
  size: number;
}

export default styled.div<BubbleChildProps>`
  border-radius: 50%;
  height: ${({ size }) => size}%;
  width: ${({ size }) => size}%;
  background-color: ${({ variant: type }) =>
    type === "user" ? "#a6be0a" : "#c9e034"};
`;
